import { Reveal } from './Reveal';
import { ArrowLinkIcon } from './icons';

const SOLUTIONS = [
  { title: 'Bulk SMS', color: '#014ed2', icon: '/landing/icon-sms.png', desc: 'Send messages to thousands of contacts in seconds with high delivery rates.' },
  { title: 'Voice Calls', color: '#2ca342', icon: '/landing/icon-voice.png', desc: 'Reach and engage customers and prospects over crystal clear voice calls.' },
  { title: 'Whatsapp', color: '#6050dc', icon: '/landing/icon-whatsapp.png', desc: 'Engage customers on their favourite platform with our WhatsApp Api.' },
  { title: 'Airtime & Data', color: '#f97d5a', icon: null, desc: 'Deliver airtime and data directly to your customers anytime anywhere.' },
  { title: 'USSD', color: '#ff4848', icon: null, desc: 'Real-time communication channels that work on any mobile device—no internet required.' },
];

export function SolutionsSection() {
  return (
    <section id="solutions" style={{ maxWidth: 1400, margin: '0 auto', padding: '96px 24px' }}>
      <Reveal>
        <h2 style={{ margin: '0 auto 12px', textAlign: 'center', maxWidth: 480, fontFamily: 'Inter, sans-serif', fontWeight: 800, fontSize: 32, color: '#152752', lineHeight: 1.15 }}>
          Powerful solutions to simplify your business communication
        </h2>
        <p style={{ margin: '0 auto 48px', textAlign: 'center', maxWidth: 590, fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 16, color: '#4c5876', lineHeight: 1.5 }}>
          Everything you need to connect with your audience and grow your business.
        </p>
      </Reveal>

      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
        {SOLUTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} style={{ flex: '1 1 230px', maxWidth: 259 }}>
            <div
              style={{
                background: '#fff', borderRadius: 10, boxShadow: '0px 1px 9px 0px rgba(67,67,67,0.1)',
                padding: '24px 20px', height: '100%', boxSizing: 'border-box',
              }}
            >
              <div style={{ width: 58, height: 59, borderRadius: 10, background: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 }}>
                {s.icon && <img src={s.icon} alt={s.title} width={30} height={30} style={{ objectFit: 'contain' }} />}
              </div>
              <p style={{ margin: '0 0 12px', fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: 18, color: '#000' }}>{s.title}</p>
              <p style={{ margin: '0 0 20px', fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 14, color: '#4c5876', lineHeight: 1.4, minHeight: 58 }}>{s.desc}</p>
              <a href="#" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#014ed2' }}>
                Learn more <ArrowLinkIcon size={18} />
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
